import { BASE_WEBSITE_V4_URL } from "..";
import Config from "../../config";
import { PostCall } from "../helper";


export const URLS = {
  "B2B_CONTACT_US": BASE_WEBSITE_V4_URL + "/landingpage/b2b/b2b_submit/",
  "ENTERPRISE_CONTACT_US": BASE_WEBSITE_V4_URL + "/landingpage/enterprise/enterprise_submit/"
}

export const ContactUs = async(data:any) => {
  return await PostCall(URLS.B2B_CONTACT_US, data, {...Config.DEFAULT_HEADER})
}

export const EnterpriseContactUs = async(data:any) => {
  return await PostCall(URLS.ENTERPRISE_CONTACT_US, data, {...Config.DEFAULT_HEADER})
}